'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

exports.default = LayoutDesktopItem;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./layout-desktop-item.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Layout Desktop Item Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>} HTML markup for the component
 */
function LayoutDesktopItem(props) {
    var _props$isFixed = props.isFixed,
        isFixed = _props$isFixed === undefined ? false : _props$isFixed,
        _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id;


    var fixedCssClass = isFixed ? ' sb-layout-desktop-item--fixed' : '';

    return (0, _jsx3.default)('section', {
        className: 'sb-layout-desktop-item' + fixedCssClass,
        id: id
    }, void 0, props.children);
}
// css
//# sourceMappingURL=LayoutDesktopItem.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/layoutDesktop/LayoutDesktopItem.js
// module id = 569
// module chunks = 0